export const DEFAULT_CATEGORIES = [
  ["Bedding & Comfort", "Supplies", "#2D4A3E"],
  ["Bathroom Supplies", "Supplies", "#4A7A66"],
  ["Kitchen Supplies", "Supplies", "#D96C5B"],
  ["Snacks & Guest Amenities", "Supplies", "#B48B57"],
  ["Decor & Furniture", "Repairs/Maintenance", "#7A5D4E"],
  ["Cleaning Supplies", "Cleaning and maintenance", "#3E6B5B"],
  ["Repairs & Maintenance", "Repairs", "#C65F4F"],
  ["Utilities", "Utilities", "#5A6C57"],
  ["Internet & TV", "Utilities", "#466A7B"],
  ["Landscaping", "Cleaning and maintenance", "#698D55"],
  ["Pest Control", "Cleaning and maintenance", "#876B42"],
  ["Software & Subscriptions", "Other", "#546A76"],
  ["Platform Fees", "Commissions", "#9A6F55"],
  ["Professional Services", "Legal and professional fees", "#6E5B7E"],
  ["Insurance", "Insurance", "#9A7B3E"],
  ["Mortgage or Rent", "Mortgage interest", "#7E5A46"],
  ["Property Taxes", "Taxes", "#885053"],
  ["HOA Fees", "Other", "#637066"],
  ["Office Supplies", "Office expense", "#697A85"],
  ["Mileage", "Auto and travel", "#355C4B"],
  ["Other", "Other", "#787672"],
];

export const PROPERTY_TYPES = ["Short-Term Rental", "Long-Term Rental", "Cabin", "Vacation Home", "Multi-Family", "Other"];
export const PLATFORMS = ["Airbnb", "VRBO", "Booking.com", "Direct Booking", "Other"];
export const PAYMENT_METHODS = ["Credit Card", "Debit Card", "Cash", "Bank Transfer", "Business Card", "Other"];
export const EXPENSE_STATUSES = ["Draft", "Needs Review", "Categorized", "Exported"];

export const emptyWorkspace = {
  profile: null,
  properties: [],
  categories: [],
  vendors: [],
  expenses: [],
  mileage: [],
  income: [],
  receipts: [],
  lineItems: [],
};